import bgImage from '../../assets/images/bg.png';
import { TextSlider } from '../../components';
import useStyles from './stylesheet';
import React from 'react';

const Home = () => {
  const classes = useStyles();

  return <div className={classes.container} id="home">
    <img src={bgImage} alt="" className={classes.img}/>
    <TextSlider className={classes.slider}/>
    <div className={classes.homeFooter}>
        {/* Üst Satır: İsim */}
        <div className={classes.titleRow}>  
          <span>Hello, I’m</span>
          <span className={classes.green}>
            Mehmet Ali Selek
          </span>
        </div>
        
        {/* Alt Satır: Unvan */}
        <div className={classes.subtitleRow}>
          Full-Stack Developer Based in Konya.
        </div>
    </div>
  </div>
}

export default Home;
